export default __webpack_public_path__ + "static/alfred_add_custom_search-15d97a52c4594510583f95d5fc0e573f.png";